import React from "react";

// Mapping of numbers to Persian words
const persianNumbers = [
  "",
  "یک",
  "دو",
  "سه",
  "چهار",
  "پنج",
  "شش",
  "هفت",
  "هشت",
  "نه",
  "ده",
  "یازده",
  "دوازده",
  "سیزده",
  "چهارده",
  "پانزده",
  "شانزده",
  "هفده",
  "هجده",
  "نوزده",
];
const tensNumbers = ["", "", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
const hundredsNumbers = ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
const scales = ["", "هزار", "میلیون", "میلیارد"];

// Function to convert three-digit numbers to Persian words
function threeDigitToWords(num) {
  let result = "";

  if (num === 0) return result;

  if (num < 20) {
    result += persianNumbers[num];
  } else if (num < 100) {
    result += tensNumbers[Math.floor(num / 10)];
    if (num % 10 !== 0) result += " و " + persianNumbers[num % 10];
  } else {
    result += hundredsNumbers[Math.floor(num / 100)];
    const remainder = num % 100;
    if (remainder !== 0) result += " و " + threeDigitToWords(remainder);
  }

  return result;
}

// Function to convert a number to Persian words with scales
function numberToPersianWords(num) {
  if (num === 0) return "صفر تومان";

  let result = "";
  let scaleIndex = 0;

  while (num > 0) {
    const part = num % 1000;
    if (part !== 0) {
      const partInWords = threeDigitToWords(part);
      if (scaleIndex > 0) result = partInWords + " " + scales[scaleIndex] + " و " + result;
      else result = partInWords + " و " + result;
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  // Remove trailing " و " and add "تومان"
  result = result.trim();
  if (result.endsWith("و")) result = result.slice(0, -2);
  return result + " تومان";
}

// Example usage in a React component
const CurrencyConverter = ({ num }) => {
  const persianWords = numberToPersianWords(num);

  return <div>{persianWords}</div>;
};

export default CurrencyConverter;
